import { render } from "./AccountCredits.vue?vue&type=template&id=13a8b699"
import script from "./AccountCredits.vue?vue&type=script&lang=js"
export * from "./AccountCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__